export function NotFound({ path, default: isDefault }: { path?: string; default?: boolean }) {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <a href="/" style={{ color: '#E07A4A' }}>Go back home</a>
    </div>
  );
}
